import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import type {
  TGetNewHireWorkersRequest,
  TGetNewHireWorkersResponse,
} from "./getNewHireWorkers.schema";

export type {
  INewHireRecord,
  INewHireWorker,
} from "./getNewHireWorkers.schema";

export const getNewHireWorkers = (axios: IAxiosInstance) => {
  return async (
    params: TGetNewHireWorkersRequest
  ): Promise<TGetNewHireWorkersResponse> => {
    const response = await axios.noRetry.get<TGetNewHireWorkersResponse>(
      `/api/new-hire-reporting/workers`,
      { params }
    );
    return response.data;
  };
};
